/* eslint-disable no-underscore-dangle */
import React from 'react';
import {
  FeedbackModalMode,
  FeedbackModalType,
  FeedbackModalContextType,
} from './types';

const FeedbackModalContext = React.createContext<FeedbackModalContextType>(
  {} as any,
);

export const FeedbackModalContextProvider: React.FC = ({ children }) => {
  const [visible, setVisible] = React.useState(false);

  const [listingId, setListingId] = React.useState<string>();
  const [appointmentId, setAppointmentId] = React.useState<string>();
  const [modalType, setModalType] = React.useState<FeedbackModalType>();
  const [modalMode, setModalMode] = React.useState<FeedbackModalMode>();
  const [onClose, setOnClose] = React.useState<() => Promise<void>>();
  const [onSubmit, setOnSubmit] = React.useState<() => Promise<void>>();

  const _resetModal = () => {
    setListingId(undefined);
    setAppointmentId(undefined);
    setModalType(undefined);
    setModalMode(undefined);
    setOnClose(undefined);
    setOnSubmit(undefined);
  };

  const memoizedValue = React.useMemo(() => {
    const openModal: FeedbackModalContextType['openModal'] = options => {
      setListingId(options.listingId);
      setAppointmentId(options.appointmentId);
      setModalType(options.modalType);
      setModalMode(options.modalMode);
      setOnClose(() => options.onClose);
      setOnSubmit(() => options.onSubmit);
      setVisible(true);
    };

    const closeModal: FeedbackModalContextType['closeModal'] = async (
      options = {
        resetModal: true,
        fireSubmit: false,
      },
    ) => {
      setVisible(false);
      if (options.fireSubmit) await onSubmit();
      if (onClose) await onClose();
      if (options.resetModal) _resetModal();
    };
    return {
      visible,
      openModal,
      closeModal,
      onClose,
      listingId,
      appointmentId,
      modalType,
      modalMode,
    };
  }, [
    appointmentId,
    onClose,
    onSubmit,
    modalType,
    modalMode,
    listingId,
    visible,
  ]);

  return (
    <FeedbackModalContext.Provider value={memoizedValue}>
      {children}
    </FeedbackModalContext.Provider>
  );
};

export default FeedbackModalContext;
